let search_toggle = ( function( $ ) {

	let	$search_toggles;

	let _init = function() {
		$search_toggles = $( 'a.search-toggle' );

		$search_toggles.on( 'click', _toggle_search );
	};

	let _toggle_search = function( e ) {
		e.preventDefault();

		let $search_container = $( this ).closest( '.search' );
		let $search           = $search_container.find( '.search-toggle-container' );

		$search.toggle( 'drop' );
		$search_container.toggleClass( 'open' );

		if ( $search_container.hasClass( 'open' ) ) {
			$search_container.find( 'input[name=s]' ).focus();
		}
	};

	if ( $( '#header-search' ).length > 0 || $( '#ocm-search' ).length ) {
		$( document ).ready( _init );
	}

} )( jQuery );

module.exports = search_toggle;